<div
  #tooltip
  class="mdc-tooltip mat-mdc-tooltip"
  [ngClass]="tooltipClass"
  (animationend)="_handleAnimationEnd($event)"
  [class.mdc-tooltip--multiline]="_isMultiline">
  <div class="mat-mdc-tooltip-surface mdc-tooltip__surface">{{message}}</div>
</div>
